import classNames from 'classnames';
import { MFLink } from '@medifind/shared-basic-components';
import styles from './ad.shared.module.scss';

const AdWrapper = ({ classes = {}, onClick, smallAds = false, icon, title, buttonText, centered = false }) => {
  return (
    <div className={classNames(styles[`container--${centered ? 'centered' : 'block'}`])}>
      <div
        className={classNames(styles['side-block'], styles['side-block__ad'], classes.container, {
          [styles['side-block__ad--smallAds']]: smallAds,
        })}
      >
        <div className={styles['subline']}>
          {icon}
          {title}
        </div>

        <MFLink onClick={onClick}>
          <div className={styles['ad-button__container']}>
            <span className={styles['ad-button']}>{buttonText}</span>
          </div>
        </MFLink>
      </div>
    </div>
  );
};

export { AdWrapper as default, AdWrapper };
